// extracted by mini-css-extract-plugin
export default {"promotionalMaterialsContainer":"PromotionalMaterials_promotionalMaterialsContainer__Uk4rA","filterBarRow":"PromotionalMaterials_filterBarRow__itSz+"};